import { render, staticRenderFns } from "./web3d.vue?vue&type=template&id=5112c57b&scoped=true&"
import script from "./web3d.vue?vue&type=script&lang=js&"
export * from "./web3d.vue?vue&type=script&lang=js&"
import style0 from "./web3d.vue?vue&type=style&index=0&id=5112c57b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5112c57b",
  null
  
)

export default component.exports